// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"X3-z","yourQuestionLabel":"Y3-z","notAuthedMessage":"Z3-z","form":"_3-z","textarea":"a4-z","error":"b4-z","disabled":"c4-z","edited":"d4-z","submit":"e4-z"};